module.exports = __webpack_public_path__ + "static/media/kyc_default.20252f7b.svg";